/* Jungle: free-delivery progress nudge.
   AOV was 42.69 against a 50.00 free-delivery threshold - customers were
   stopping just short of it without being told. Reads the real cart, shows
   how far off they are, and stays silent when it has nothing useful to say. */
(function () {
  'use strict';

  var THRESHOLD = 5000;            // pence; overridden by window.JUNGLE_FREE_DELIVERY
  var ONLY_COUNTRIES = ['GBP'];    // free UK delivery only - do not promise it elsewhere

  if (window.JUNGLE_FREE_DELIVERY) THRESHOLD = window.JUNGLE_FREE_DELIVERY;

  function money(pence, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
        { style: 'currency', currency: currency || 'GBP' }).format(pence / 100);
    } catch (e) { return '£' + (pence / 100).toFixed(2); }
  }

  function bar(cart) {
    var total = cart.total_price || 0;
    var cur = cart.currency || 'GBP';
    if (ONLY_COUNTRIES.indexOf(cur) === -1) return null;   // wrong market, say nothing
    if (!cart.item_count) return null;                     // empty cart, say nothing

    var left = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));
    var el = document.createElement('div');
    el.className = 'jfd';
    el.setAttribute('data-jfd', '1');
    if (left > 0) {
      el.innerHTML =
        '<p class="jfd__msg">Add <strong>' + money(left, cur) +
        '</strong> more for <strong>free UK delivery</strong></p>' +
        '<div class="jfd__track"><i style="width:' + pct.toFixed(1) + '%"></i></div>';
    } else {
      el.classList.add('jfd--done');
      el.innerHTML = '<p class="jfd__msg">&#10003; Your order qualifies for '
        + '<strong>free UK delivery</strong></p>'
        + '<div class="jfd__track"><i style="width:100%"></i></div>';
    }
    return el;
  }

  // Where the bar should sit, most specific first.
  var TARGETS = [
    '.cart-drawer__inner', '.cart-drawer', 'cart-drawer-component',
    '.cart-summary__inner', '.cart-summary', '.cart__items', '#main-cart', 'main .cart'
  ];

  function place(el) {
    for (var i = 0; i < TARGETS.length; i++) {
      var host = document.querySelector(TARGETS[i]);
      if (host) { host.insertBefore(el, host.firstChild); return true; }
    }
    return false;
  }

  var busy = false;
  function refresh() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        Array.prototype.forEach.call(
          document.querySelectorAll('[data-jfd]'), function (n) { n.remove(); });
        var el = bar(cart);
        if (el) place(el);
      })
      .catch(function () { /* never break the cart over a nudge */ })
      .then(function () { busy = false; });
  }

  function schedule() { clearTimeout(schedule._t); schedule._t = setTimeout(refresh, 250); }

  // Re-check after anything that changes the cart.
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = _fetch.apply(this, arguments);
    if (typeof url === 'string' && url.indexOf('/cart') !== -1) p.then(schedule, function () {});
    return p;
  };
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches && (n.matches('cart-drawer-component, .cart-drawer, .cart-summary') ||
              n.querySelector && n.querySelector('cart-drawer-component, .cart-drawer, .cart-summary')))) {
            schedule(); return;
          }
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else { schedule(); }
})();
